var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappinIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3487 18.4956C14.3822 16.7406 18 13.155 18 9.86456C18 8.04397 17.2625 6.29794 15.9497 5.01058C14.637 3.72323 12.8565 3 11 3C9.14348 3 7.36301 3.72323 6.05025 5.01058C4.7375 6.29794 4 8.04397 4 9.86456C4 13.155 7.61667 16.7406 9.65133 18.4956C10.0225 18.8205 10.5025 19 11 19C11.4975 19 11.9775 18.8205 12.3487 18.4956ZM8.66667 9.86456C8.66667 9.2577 8.9125 8.67569 9.35008 8.24657C9.78767 7.81745 10.3812 7.57637 11 7.57637C11.6188 7.57637 12.2123 7.81745 12.6499 8.24657C13.0875 8.67569 13.3333 9.2577 13.3333 9.86456C13.3333 10.4714 13.0875 11.0534 12.6499 11.4826C12.2123 11.9117 11.6188 12.1527 11 12.1527C10.3812 12.1527 9.78767 11.9117 9.35008 11.4826C8.9125 11.0534 8.66667 10.4714 8.66667 9.86456Z",
    fill: "#E5602F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappinIconRed);
export default __webpack_public_path__ + "static/media/mappin-icon-red.0a05092742a98e6042d617acdf94c7a3.svg";
export { ForwardRef as ReactComponent };